import { coreApi } from '$api'
import { IRosteredShiftResponse } from '$models'
import { singletonQueryClient } from '$utils'
import { Dayjs } from 'dayjs'

enum QueryKeys {
  getRosteredShifts = 'rostered-shifts',
}

/**
 * Get rostered shifts by date range
 * @returns an array of invoices
 */
export const getAll = async (
  startTime: Dayjs,
  endTime: Dayjs,
  rosterId?: string,
  includeDeleted: boolean = false,
  includeUnpublishedShifts: boolean = true,
  staffMemberIds: string[] = []
): Promise<IRosteredShiftResponse[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [
      QueryKeys.getRosteredShifts,
      startTime,
      endTime,
      rosterId,
      includeDeleted,
      includeUnpublishedShifts,
      staffMemberIds,
    ],
    queryFn: async ({ signal }) => {
      const rosteredShifts = await coreApi.getRosteredShifts(
        rosterId,
        startTime,
        endTime,
        includeDeleted,
        includeUnpublishedShifts,
        staffMemberIds,
        signal
      )

      return rosteredShifts
    },
  })
}
